import "./Card.scss";

interface Props {
  children;
  size?: "extra-large" | "large" | "medium" | "small";
  secondary?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  disableWatermark?: boolean;
  boldWatermark?: boolean;
}

export const Card = ({
  children,
  size = "medium",
  secondary = false,
  className = "",
  style,
  onClick,
  disableWatermark = false,
  boldWatermark = false,
}: Props) => {
  return (
    <div
      className={`card card__${size} ${disableWatermark ? "" : "relative"} ${secondary ? "card__secondary" : ""} }
      ${className}`}
      style={style}
      onClick={onClick}
    >
      {!disableWatermark && (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div
            className={`watermark ${boldWatermark ? "watermark-bold" : ""}`}
          ></div>
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
